/// <amd-module name="Analytics/Boards/VelocityQueries/VelocityDataHelper" />
import { AggregationMode, ModefulValueSetting } from "Analytics/Boards/BoardsQueries/DataContracts";
import { WitFieldUtilities } from "Analytics/Boards/BoardsQueries/WitFieldUtilities";

/**
 *  Helper method gets string snippits for performing aggregations with the Velocity Widget
 */
export class VelocityDataHelper {
    public static getQueryAggregation(aggregation: ModefulValueSetting<AggregationMode, string>): string {
        switch (aggregation.identifier) {
            case AggregationMode.Sum:
                const odataPropertyName = WitFieldUtilities.getFieldODataPropertyName(aggregation.settings);
                if (odataPropertyName == null || odataPropertyName.trim().length === 0) {
                    throw new Error(`No property name found for aggregation setting: '${aggregation.settings}'`);
                }

                return `aggregate(${odataPropertyName} with sum as AggregationResult)`;
            case AggregationMode.Count:
                return `aggregate($count as AggregationResult)`;
            default:
                throw new Error(`Unexpected aggregation mode: '${aggregation.identifier}'`);
        }
    }
}
